export const arrayToObject = (
  array: Array<{ [key: string]: any }> = [],
  key: string = 'key',
) => Object.assign({}, ...array.map((item) => ({ [item[key]]: item })))
